export const tasks = [
    //CAT 1 - OUVERTURE
    {
        id: '102',
        title: 'Allumer toutes les lumières du bar',
        order: 2,
        catId: '1',
        contentBlocks: [
            {
                tag: 'p',
                content: "Allumez toutes les lumières, et il y en a quelques unes !",
                order: '1'
            },
            {
                tag: 'div',
                content: "<ul><li>L'estrade : il faut brancher les deux prises au bas du mur, près de la porte de la bibliothèque</li></ul>",
                order: '2'
            }
        ]
    },
    {
        id: '101',
        title: 'Récupérer le matériel au bureau',
        order: 1,
        catId: '1',
        contentBlocks: [
            {
                tag: 'p', 
                content: "Le trousseau du bar se trouve dans le clefier du bureau, il porte un tire-bouchon, vous pouvez pas el louper !",
                order: '1'
            }, 
            {
                tag: 'p', 
                content: "Prenez la caisse grise, elle se trouve près du meuble blanc, et vérifiez que tout y est :) :",
                order: '2'
            }, 
            {
                tag: 'div', 
                content: '<ul><li>Ipad</li><li>Chargeur Ipad</li><li>Les deux becs pour la machine à café</li><li>Temimnal bancontact bar</li><li>En journée, pour les permanence, prenez aussi le terminal bancontact billetterie</li><li>Les feuilles de caisse vide et les envelopeps</li><li>Les tickets parking (s\'il n\'y en a plus, <em>PREVENEZ LILI !</em>)</li></ul>',
                order: '3'
            },
            {
                tag: 'p',
                content: "BONUS ;) Au passage, vérifier s'il y a des glaçons dans le congel. Si oui, prenez les et placez les dans le frigo à bière",
                order: '4'
            }
        ]

    },

    // CAT 2 - FERMETURE

    {
        id:'201',
        order: 1,
        catId: '2',
        title: 'Fermer portes, sas et volets'
    },
    
    // CAT 3 - PENDANT LE SHIFT
    
    {
        id:'301',
        order: 1,
        catId: '3',
        title: 'Surveillance'
    }
    
    // CAT 4 - PASSWORDS
    // TODO Secure the app !
]